/*models/selections/index*/
function _(require, module, exports) {
    var tslib_1 = require(380    /* tslib */);
    tslib_1.__exportStar(require(180    /* ./interaction_policy */), exports);
    var selection_1 = require(181    /* ./selection */);
    exports.Selection = selection_1.Selection;    
}